import { combineReducers } from "redux";
import AnalyticsReducers from "./analytics";
import AuthReducers from "./auth";
import PlayerReducers from "./player";
import SiteReducers from "./site";
import VideoReducers from "./video";
import AppReducers from "./app";
import AIVideoReducers from "./aiVideo";

const RootReducer = combineReducers({
  ...AnalyticsReducers,
  ...AuthReducers,
  ...PlayerReducers,
  ...SiteReducers,
  ...VideoReducers,
  ...AIVideoReducers,
  ...AppReducers,
});

export default RootReducer;
